import { Box, IconButton, Table, TableBody, TableHead, TableRow } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  LabelContent,
  HeadTableCell,
  RowTableCell,
} from '../../../common';
import { formatDate, formatCurrency } from '../utils/regularizedPlansUtils';

const RegularizedPlansDetailsDialog = ({ open, onClose, item }) => {
  const handlePrint = () => {
    const originalSize = document.body.style.zoom;
    document.body.style.zoom = '70%';
    window.print();
    document.body.style.zoom = originalSize;
  };

  if (!item) return null;

  return (
    <DialogContainer 
      open={open} 
      onClose={onClose} 
      size="large"
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '90vh',
          overflow: 'auto',
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          CUOTAS REGULARIZADAS
          <IconButton onClick={handlePrint}>
            <PrintIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogBody>
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <LabelContent 
            label="ORDEN NÚMERO" 
            content={item.header?.contract_number} 
            labelColor="primary.main" 
          />
          <LabelContent 
            label="SUSCRIPTOR" 
            content={item.header?.subscriber} 
            labelColor="primary.main" 
          />
        </Box>

        <Box sx={{ 
          overflow: 'auto',
          maxWidth: '100%',
          border: '1px solid #e0e0e0',
          borderRadius: 1,
        }}>
          <Table aria-label="regularized coupons table">
            <TableHead>
              <TableRow>
                <HeadTableCell>Número Cuota</HeadTableCell>
                <HeadTableCell>Fecha 1er Venc.</HeadTableCell>
                <HeadTableCell>Importe 1er Venc.</HeadTableCell>
                <HeadTableCell>Fecha 1ra Regulariz.</HeadTableCell>
                <HeadTableCell>Importe 1ra Regulariz.</HeadTableCell>
                <HeadTableCell>Fecha 2da Regulariz.</HeadTableCell>
                <HeadTableCell>Importe 2da Regulariz.</HeadTableCell>
                <HeadTableCell>Importe regularizado</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {item.coupons?.map((coupon, index) => (
                <TableRow key={index}>
                  <RowTableCell>{coupon.fee_number1 ? coupon.fee_number1 : "Adecuación"}</RowTableCell>
                  <RowTableCell>{formatDate(coupon.first_due_date)}</RowTableCell>
                  <RowTableCell>{formatCurrency(coupon.first_due_amount)}</RowTableCell>
                  <RowTableCell>{formatDate(coupon.regulariza1_date)}</RowTableCell>
                  <RowTableCell>{formatCurrency(coupon.regulariza1_amount)}</RowTableCell>
                  <RowTableCell>
                    {coupon.regulariza2_date
                      ? formatDate(coupon.regulariza2_date)
                      : "-"
                    }
                  </RowTableCell>
                  <RowTableCell>{coupon.regulariza2_amount ? formatCurrency(coupon.regulariza2_amount) : "-"}</RowTableCell>
                  <RowTableCell>{formatCurrency(coupon.regulariza1_amount)}</RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

        <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 2,
          mr: 2,
          gap: 3,
        }}>
          <LabelContent 
            label="Cuotas regularizadas" 
            content={item.header?.regularized_fees} 
            labelColor="primary.main"
            sx={{ fontSize: '16px', fontWeight: 'medium' }}
          />
          <LabelContent 
            label="Total regularizado" 
            content={formatCurrency(item.header?.total)} 
            labelColor="primary.main"
            sx={{ fontSize: '16px', fontWeight: 'bold' }}
          />
        </Box>
      </DialogBody>
    </DialogContainer>
  );
};

export default RegularizedPlansDetailsDialog;